import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import { Group, Radio } from "@mantine/core";
import { useForm, Controller } from "react-hook-form";
import AsyncSelect from "react-select/async";
import CustomDateAndTime from "../../../../../../components/customDateAndTime/CustomDateAndTime";
import CustomDOBPicker from "../../../../../../components/CustomDOBPicker";
import CustomButton from "../../../../../../components/CustomButton";
import {ReactComponent as ClockIcon} from "../../../../../../assets/clock.svg"
import moment from "moment";
const ActualFlightTaken = ({
  onSubmit,
  flightDetails,
  setStepfour,
  actualFlightDetails,
  setActualFlightDetails,
  setIsFlightProvided,
  isFlightProvided,
  loadOptions,
  flightOptions,
  setTriggerIndex,
  setTriggerFrom,
  loadAirlineOptions,
  defaultOptions,
  defaultAirlineOptions,
  removeActualFlightDetails,
  RemoveCircleOutline,
  flightClassOptions,
  type_of_claim,
  lostAmount,
  setLostAmount
}) => {
  const LOCAL_STORAGE_KEY = "actualFlightDetailsData";

  const [dateError, setDateError] = useState(null);
  const [departureDateError, setDepartureDateError] = useState(null);

  // Date and time validation functions
  const validateDates = (
    departureDate,
    departureTime,
    arrivalDate,
    arrivalTime
  ) => {
    if (!departureDate || !arrivalDate) return true;

    const departure = new Date(`${departureDate}T${departureTime || "00:00"}`);
    const arrival = new Date(`${arrivalDate}T${arrivalTime || "00:00"}`);

    return arrival >= departure;
  };

  const parseDMY = (dateStr) => {
    if (dateStr == null || dateStr === undefined || dateStr === "")
      return false;
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split("-");
      return new Date(`${year}-${month}-${day}`);
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split("-");
      return new Date(`${year}-${month}-${day}`);
    }

    return dateStr;
  };

  const validateTimes = (departureTime, arrivalTime) => {
    if (!departureTime || !arrivalTime) return true;

    const [depHours, depMins] = departureTime.split(":").map(Number);
    const [arrHours, arrMins] = arrivalTime.split(":").map(Number);

    return arrHours > depHours || (arrHours === depHours && arrMins > depMins);
  };

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors, isValid },
    setValue: setFormValue,
    reset,
    getValues,
    trigger,
  } = useForm({
    defaultValues: {
      actual_flight_details: [],
    },
    mode: "onChange",
  });


  const setManualEntryIndex = (index) => {
    const updatedFlightDetails = [...actualFlightDetails];
    updatedFlightDetails[index].manual = true;
    setActualFlightDetails(updatedFlightDetails);
  }

   const setTimeIndex = (key,index,type) => {
    const updatedFlightDetails = [...actualFlightDetails];
    updatedFlightDetails[index][key] = type;
    setActualFlightDetails(updatedFlightDetails);
  }

  const formatTimeInput = (value) => {
  // Remove non-digits
  let digits = value.replace(/\D/g, "");

  // Limit max 4 digits (HHMM)
  if (digits.length > 4) digits = digits.slice(0, 4);

  // Insert colon after 2 digits
  if (digits.length > 2) {
    digits = digits.slice(0, 2) + ":" + digits.slice(2);
  }

  return digits;
};

// Formatter: strips colons from raw input, inserts colon automatically for display.
// Keeps leading zeros, clamps numbers, allows trailing A/P/AM/PM.
// FORMATTER: handles auto-colon, clamps hours/minutes, preserves leading zeros,
// expands 'A'->'AM' and 'P'->'PM' after full time.
const formatTo12Hour = (raw) => {
  if (!raw) return "";

  // keep only digits, letters A/P/M, and spaces (strip any colons the user typed)
  let s = raw.replace(/[^0-9APMapm\s]/g, "").toUpperCase().trim();

  // detect trailing letters
  let trailingMatch = s.match(/(AM|PM|A|P)?$/i);
  let trailing = trailingMatch ? trailingMatch[0].toUpperCase() : "";

  // remove trailing letters from main
  let main = s.replace(/(AM|PM|A|P)$/i, "");

  const digits = (main.match(/\d/g) || []).join("");

  // helpers
  const clampHour = (h) => Math.min(parseInt(h || "0", 10) || 0, 12);
  const clampMinute = (m) => Math.min(parseInt(m || "0", 10) || 0, 59);

  // nothing typed
  if (digits.length === 0) return trailing;

  // 1–2 digits: hour only
  if (digits.length <= 2) {
    if (parseInt(digits, 10) > 12) return "12" + (trailing ? " " + trailing : "");
    return digits + (trailing ? " " + trailing : "");
  }

  // 3 digits: HH:M
  if (digits.length === 3) {
    const hhRaw = digits.slice(0, 2);
    const mmRaw = digits.slice(2, 3);

    const hhNum = clampHour(hhRaw);
    const hhDisplay = parseInt(hhRaw, 10) > 12 ? "12" : hhRaw;
    return `${hhDisplay}:${mmRaw}${trailing ? " " + trailing : ""}`;
  }

  // 4+ digits: HH:MM
  const hhRaw = digits.slice(0, 2);
  const mmRaw = digits.slice(2, 4);

  const hhDisplay = parseInt(hhRaw, 10) > 12 ? "12" : hhRaw;
  const mmNum = clampMinute(mmRaw);
  const mmDisplay = parseInt(mmRaw, 10) > 59 ? String(mmNum).padStart(2, "0") : mmRaw;

  // expand single-letter trailing to full AM/PM
  if (trailing === "A") trailing = "AM";
  if (trailing === "P") trailing = "PM";

  return `${hhDisplay}:${mmDisplay}${trailing ? " " + trailing : ""}`;
};

// KEYDOWN: block colon, allow digits (up to 4), then only A/P for AM/PM.
const handleTimeKeyDown = (e) => {
  const el = e.target;
  const value = el.value || "";
  const start = el.selectionStart;
  const end = el.selectionEnd;

  if (e.ctrlKey || e.metaKey || e.altKey) return;

  // always allow nav keys
  const nav = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Home", "End"];
  if (nav.includes(e.key)) return;

  // block colon
  if (e.key === ":") {
    e.preventDefault();
    return;
  }

  // allow replacing selection
  if (start !== end) return;

  // allow editing in middle
  if (start !== value.length) return;

  // digits: only until 4 digits typed
  const digitsInTime = (value.replace(/\s?(AM|PM)$/i, "").match(/\d/g) || []).length;
  if (/^[0-9]$/.test(e.key)) {
    if (digitsInTime >= 4) {
      e.preventDefault();
    }
    return;
  }

  // allow A/P to trigger AM/PM
  if (/^[APap]$/.test(e.key)) return;

  // block everything else
  e.preventDefault();
};




/* --- Example React usage --- 

<input
  {...field}
  ref={timeRef}
  type="text"
  placeholder="h:mm AM/PM"
  className="custom-time-input"
  disabled={flight?.manual !== true}
  onKeyDown={handleTimeKeyDown}
  onChange={(e) => {
    const corrected = formatTo12Hour(e.target.value);
    field.onChange(corrected);

    // update flight details state as you already do
    setDepartureDateError(null);
    const updatedFlightDetails = [...actualFlightDetails];
    updatedFlightDetails[index].actual_departure_time = corrected;
    setActualFlightDetails(updatedFlightDetails);

    setFormValue(
      `actual_flight_details[${index}].actual_departure_time`,
      corrected
    );
    setTriggerIndex(null);
  }}
/>

*/

/* Quick behaviour examples:
   "8"    -> "8"
   "08"   -> "08"        (preserved)
   "13"   -> "12"        (clamped)
   "812"  -> "8:12"
   "0812" -> "08:12"     (preserved leading zero)
   "1299" -> "12:59"     (minutes clamped)
   After full HH:MM -> extra digits blocked; typing "a" -> "HH:MM A" -> then "AM"
*/


function convertTime(input) {
  let m;

  // Detect format
  if (/am|pm/i.test(input)) {
    // Input is 12-hour format -> convert to 24-hour
    m = moment(input, "hh:mm A");
    return m.format("HH:mm");
  } else {
    // Input is 24-hour format -> convert to 12-hour
    m = moment(input, "HH:mm");
    return m.format("hh:mm A");
  }
}

const autoCorrectTime = (time) => {
  if (!/^\d{2}:\d{2}$/.test(time)) return time;

  let [hh, mm] = time.split(":").map(Number);

  // Auto-correct hours
  if (hh > 23) hh = 23;

  // Auto-correct minutes
  if (mm > 59) mm = 59;

  return `${hh.toString().padStart(2, "0")}:${mm
    .toString()
    .padStart(2, "0")}`;
};


  // useEffect(() => {
  //   console.log(isValid);

  //   if (isFlightProvided === "no") {
  //     setStepfour(true);
  //     return;
  //   }

  //   if (isValid) {
  //     if (isFlightProvided) {
  //       setStepfour(true);
  //     } else {
  //       setStepfour(false);
  //     }
  //   } else {
  //     setStepfour(false);
  //   }
  // }, [isValid, isFlightProvided]);




      



   const typingTimeouts = useRef({});
  
    // cleanup on unmount
    useEffect(() => {
      return () => {
        Object.values(typingTimeouts.current).forEach((t) => clearTimeout(t));
      };
    }, []);
  
    const DEBOUNCE_MS = 600; // change delay as needed



  // Load initial data from localStorage or props
  useEffect(() => {
    const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);

        // Only use localStorage data if no actualFlightDetails passed from parent
        if (!actualFlightDetails || actualFlightDetails.length === 0) {
          setActualFlightDetails(parsedData.actualFlightDetails);
          setIsFlightProvided(parsedData.isFlightProvided || "no");
          reset({
            actual_flight_details:
              parsedData.formValues.actual_flight_details || [],
          });
        }
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }

      trigger();
    } else if (actualFlightDetails && actualFlightDetails.length > 0) {
      // Initialize form with actualFlightDetails from props
      reset({
        actual_flight_details: actualFlightDetails.map((flight) => ({
          actual_airline: flight.actual_airline || "",
          actual_flight_number: flight.actual_flight_number || "",
          actual_airport_of_origin: flight.actual_airport_of_origin || "",
          actual_airport_of_destination:
            flight.actual_airport_of_destination || "",
          actual_date_of_travel: flight.actual_date_of_travel || "",
          actual_departure_time: flight.actual_departure_time || "",
          actual_arrival_date: flight.actual_arrival_date || "",
          actual_arrival_time: flight.actual_arrival_time || "",
          provided_by_airline: flight.provided_by_airline || false,
          self_booked: flight.self_booked || false,
          same_as_original: flight.same_as_original || false,
        })),
      });

      trigger();
    }
  }, []);

  // Save data to localStorage whenever it changes
  useEffect(() => {
    const formData = getValues();
    const dataToSave = {
      formValues: formData,
      actualFlightDetails: actualFlightDetails,
      isFlightProvided: isFlightProvided,
    };

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToSave));
  }, [actualFlightDetails, isFlightProvided, getValues]);

  useEffect(() => {
    actualFlightDetails.forEach((flight, index) => {
      setFormValue(
        `actual_flight_details[${index}].actual_airline`,
        flight.actual_airline
      );
      setFormValue(
        `actual_flight_details[${index}].actual_flight_number`,
        flight.actual_flight_number
      );
      setFormValue(
        `actual_flight_details[${index}].same_as_original`,
        flight.same_as_original
      );
      setFormValue(
        `actual_flight_details[${index}].actual_airport_of_origin`,
        flight.actual_airport_of_origin
      );
      setFormValue(
        `actual_flight_details[${index}].actual_airport_of_destination`,
        flight.actual_airport_of_destination
      );
      setFormValue(
        `actual_flight_details[${index}].actual_date_of_travel`,
        flight.actual_date_of_travel
      );
      setFormValue(
        `actual_flight_details[${index}].actual_departure_time`,
        flight.actual_departure_time
      );
      setFormValue(
        `actual_flight_details[${index}].actual_arrival_date`,
        flight.actual_arrival_date
      );
      setFormValue(
        `actual_flight_details[${index}].actual_arrival_time`,
        flight.actual_arrival_time
      );
      setFormValue(
        `actual_flight_details[${index}].ticket_ref_no`,
        flight.ticket_ref_no
      );
      setFormValue(
        `actual_flight_details[${index}].actual_flight_class`,
        flight.actual_flight_class
      );

      setFormValue(
        `actual_flight_details[${index}].flight_provider`,
        flight?.provided_by_airline
          ? "provided_by_airline"
          : actualFlightDetails[index]?.self_booked
          ? "self_booked"
          : ""
      );
    });
  }, [actualFlightDetails, setFormValue]);




     useEffect(() => {
        if (actualFlightDetails && actualFlightDetails.length > 0 && isFlightProvided === "yes") {
          console.log(actualFlightDetails)
          let allDetailsHave = false;
   
          if (type_of_claim === "lost/damaged") {
           const allFields = actualFlightDetails.every((flight) => flight.actual_airline !== '' && flight.actual_flight_number !== '' && flight.actual_airport_of_origin !== '' && flight.actual_airport_of_destination !== '' && flight.actual_date_of_travel !== '' && flight.actual_departure_time !== '' && flight.actual_arrival_time !== ''  &&flight.actual_arrival_date !== '' && flight.actual_flight_class !== '' )
            
            if (lostAmount && allFields) {
                allDetailsHave = true
            } else {
              allDetailsHave = false
            }

          } else {
           allDetailsHave = actualFlightDetails.every((flight) => flight.actual_airline !== '' && flight.actual_flight_number !== '' && flight.actual_airport_of_origin !== '' && flight.actual_airport_of_destination !== '' && flight.actual_date_of_travel !== '' && flight.actual_departure_time !== '' && flight.actual_arrival_time !== ''  &&flight.actual_arrival_date !== '' && flight.actual_flight_class !== '' && (flight.self_booked || flight.provided_by_airline))
          }
          if (allDetailsHave) {
            setStepfour(true)
            
          } else {
            setStepfour(false)
          }
   
        } else if (isFlightProvided === "no") {
          setStepfour(true)
        } else {
          setStepfour(false)
      }
  },[actualFlightDetails,isFlightProvided,lostAmount])



  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    if (ddmmyyyy.test(value) || yyyymmdd.test(value)) {
      return true;
    }

    return "Date must be in mm-dd-yyyy format";
  };





  const handleFormSubmit = (data) => {
    if (!isFlightProvided) {
      setError("Please select an option");
      return;
    }

    

   

    const mergedData = {
      ...data,
      actual_flight_details: data.actual_flight_details.map(
        (flight, index) => ({
          ...flight,
          // Include any additional fields from flightDetails that might be missing
          actual_airline:
            actualFlightDetails[index]?.actual_airline || flight.actual_airline,
          actual_flight_number:
            actualFlightDetails[index]?.actual_flight_number ||
            flight.actual_flight_number,

          same_as_original:
            actualFlightDetails[index]?.same_as_original ||
            flight.same_as_original,
          actual_airport_of_origin:
            actualFlightDetails[index]?.actual_airport_of_origin ||
            flight.actual_airport_of_origin,
          actual_airport_of_destination:
            actualFlightDetails[index]?.actual_airport_of_destination ||
            flight.actual_airport_of_destination,
          actual_date_of_travel:
            actualFlightDetails[index]?.actual_date_of_travel ||
            flight.actual_date_of_travel,

          actual_arrival: `${actualFlightDetails[index]?.actual_arrival_date}T${
            actualFlightDetails[index]?.actual_arrival_time?.trim()
              ? actualFlightDetails[index].actual_arrival_time
              : "00:00"
          }`,
          actual_departure: `${
            actualFlightDetails[index]?.actual_date_of_travel
          }T${
            actualFlightDetails[index]?.actual_departure_time?.trim()
              ? actualFlightDetails[index].actual_departure_time
              : "00:00"
          }`,

          actual_arrival_time:
            actualFlightDetails[index]?.actual_arrival_time ||
            flight.actual_arrival_time,
          actual_departure_time:
            actualFlightDetails[index]?.actual_departure_time ||
            flight.actual_departure_time,
          ticket_ref_no:
            actualFlightDetails[index]?.ticket_ref_no || flight.ticket_ref_no,
          provided_by_airline:
            actualFlightDetails[index]?.provided_by_airline ||
            flight.provided_by_airline,
          self_booked:
            actualFlightDetails[index]?.self_booked || flight.self_booked,
        })
      ),
    };

    // Save before submission
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({
        formValues: data,
        actualFlightDetails: mergedData.actual_flight_details,
        isFlightProvided: isFlightProvided,
      })
    );

    

    onSubmit(mergedData);
  };

  const [error, setError] = useState(null);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      // width: "280px",
      // maxWidth: "280px",
      // minWidth: "280px",
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
    singleValue: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? "#222" : "#222",
      opacity: 1,
    }),
  };

  const dateRef = useRef(null);
  const timeRef = useRef(null);

  const [dateInputType, setDateInputType] = useState("text");
  const [timeInputType, setTimeInputType] = useState("text");
  const [dateInputType2, setDateInputType2] = useState("text");
  const [timeInputType2, setTimeInputType2] = useState("text");

  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          {
            type_of_claim === "lost/damaged" ? "Flight details":"Actual flights taken"
          }
        </h3>
           
      </div>
      <form onSubmit={handleSubmit(handleFormSubmit)} id="actual-flight-form">
     
        {
          type_of_claim !== "lost/damaged" &&   <div>
          <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
            Did you take a different flight than originally booked? <span style={{color:"#de8385"}}>*</span>
          </h4>
          <div className="stepper-container flight-check-wrapper">
            <div className="radio-options-wrapper">
              <Radio.Group
                value={isFlightProvided}
                onChange={(value) => setIsFlightProvided(value)}
              >
                <div className="flight-check-radio-wrapper">
                  <Radio
                    color="red"
                    // checked
                    variant="outline"
                    value={"yes"}
                    label="Yes"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value={"no"}
                    label="No"
                  />
                </div>
              </Radio.Group>
              {error && (
                <p style={{ color: "red", marginTop: "5px" }}>{error}</p>
              )}
            </div>
          </div>
        </div>
        }
        
      


        {isFlightProvided === "yes" && (


          <>
            

             {
                    type_of_claim === "lost/damaged" && <>
                   <h4
                    className="stepper-sub-header"
                    style={{ marginBottom: "15px" }}
                  >
                    Estimated value of the claim?
                    <span style={{ color: "#de8385" }}> *</span>
                  </h4>

                  <div className="grid-two">
                    <div className="custom-input">
                      
                                              <label className="input-label">
                                              Estimated amount
                                              <span style={{ color: "#de8385" }}> *</span>
                    </label>
                    
                     <input
                                
                                className="input-box"
                                placeholder="Enter the amount"
                                type="text"
                                value={lostAmount}
                                
                                onChange={(e) => {
                                  // Allow only alphanumeric, convert to uppercase
                                const cleanedValue = e.target.value
  .replace(/[^0-9.]/g, "")
  .replace(/(\..*)\./g, "$1")
  .replace(/^(\d+\.?\d{0,2}).*$/, "$1");
                                  
                                  
                                  setLostAmount(cleanedValue)

                                  
 }}
                              />
                      
                                               </div>
                  </div>

                 
                    
                    </>
                  }
            {actualFlightDetails.length > 0 &&
              actualFlightDetails.map((flight, index) => (
                <div key={index}>
                  <div className="flight-add-wrapper">
                    <h3>Flight {index + 1}</h3>
                    {actualFlightDetails.length > 1 && (
                      <div
                        style={{
                          backgroundColor: "none",
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "2px",
                        }}
                        onClick={() => removeActualFlightDetails(index)}
                      >
                        <RemoveCircleOutline />
                      </div>
                    )}
                  </div>

                  {
                    type_of_claim !== "lost/damaged" && <>
                   <h4
                    className="stepper-sub-header"
                    style={{ marginBottom: "5px" }}
                  >
                    How was this flight provided?{" "}
                    <span style={{ color: "#de8385" }}> *</span>
                  </h4>

                  <div className="grid-two">
                    <Controller
                      name={`actual_flight_details[${index}].flight_provider`}
                      control={control}
                      rules={{
                        required: "Please select a flight provider",
                      }}
                      render={({ field }) => (
                        <Radio.Group
                          value={
                            actualFlightDetails[index]?.provided_by_airline
                              ? "provided_by_airline"
                              : actualFlightDetails[index]?.self_booked
                              ? "self_booked"
                              : ""
                          }
                          onChange={(selectedValue) => {
                            setActualFlightDetails((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                ...updated[index],
                                provided_by_airline:
                                  selectedValue === "provided_by_airline",
                                self_booked: selectedValue === "self_booked",
                              };
                              return updated;
                            });

                            // Send the boolean value to react-hook-form
                            field.onChange(selectedValue);
                          }}
                        >
                          <div
                            className="flight-method-radio-wrapper"
                            style={{ marginBottom: "0px" }}
                          >
                            <Radio
                              value="self_booked"
                              label="Booked this flight myself"
                            />
                            <Radio
                              value="provided_by_airline"
                              label="Airline rebooked me"
                            />
                          </div>
                        </Radio.Group>
                      )}
                    />
                  </div>

                  {errors.actual_flight_details?.[index]?.flight_provider && (
                    <p className="errormessage">
                      {
                        errors.actual_flight_details[index].flight_provider
                          .message
                      }
                    </p>
                  )}   
                    
                    </>
                  }
                

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "35px",
                      marginTop:"30px"
                    }}
                  >
                    <div className="file-a-claim">
                      <h4
                        className="stepper-sub-header"
                        style={{ marginBottom: "5px" }}
                      >
                        Provide details of the flights you actually took.
                      </h4>

                      {flightDetails[index] && type_of_claim !== "lost/damaged" && (
                        <Controller
                          name={`actual_flight_details[${index}].same_as_original`}
                          control={control}
                          render={({ field }) => (
                            <label className="actual-flight-check-box-wrapper">
                              <input
                                type="checkbox"
                                {...field} // Important: keeps checkbox in sync with React Hook Form
                                checked={field.value}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  field.onChange(checked); // Update RHF state

                                  console.log(flightDetails[index]);

                                  const originalFlight = flightDetails[index];

                                  const updatedFlightDetails = [
                                    ...actualFlightDetails,
                                  ];
                                  if (checked) {
                                    console.log("calling");

                                    updatedFlightDetails[index].actual_airline =
                                      originalFlight.airline;
                                    
                                      updatedFlightDetails[index].actual_hub_code =
                                      originalFlight.hub_code;

                                    updatedFlightDetails[
                                      index
                                    ].actual_airport_of_origin =
                                      originalFlight.airport_of_origin;

                                    updatedFlightDetails[
                                      index
                                    ].actual_flight_number =
                                      originalFlight.flight_number;

                                    updatedFlightDetails[
                                      index
                                    ].actual_airport_of_destination =
                                      originalFlight.airport_of_destination;

                                    updatedFlightDetails[
                                      index
                                    ].actual_date_of_travel =
                                      originalFlight.actual_departure_date;
                                    updatedFlightDetails[
                                      index
                                    ].actual_departure_time =
                                      originalFlight.actual_departure_time;
                                    updatedFlightDetails[
                                      index
                                    ].actual_arrival_date =
                                      originalFlight.actual_arrival_date;
                                    updatedFlightDetails[
                                      index
                                    ].actual_arrival_time =
                                      originalFlight.actual_arrival_time;

                                    updatedFlightDetails[
                                      index
                                    ].actual_flight_class =
                                      originalFlight.flight_class;

                                    updatedFlightDetails[
                                      index
                                    ].same_as_original = true;

                                    // console.log(
                                    //   "Inside Actual =================> ",
                                    //   updatedFlightDetails
                                    // );
                                    // // setFormValue(
                                    // //   `actual_flight_details[${index}].actual_flight_number`,
                                    // //   originalFlight.flight_number
                                    // // );
                                  } else {
                                    updatedFlightDetails[index].actual_airline =
                                      "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_airport_of_origin = "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_flight_number = "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_airport_of_destination = "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_date_of_travel = "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_departure_time = "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_arrival_date = "";
                                    updatedFlightDetails[
                                      index
                                    ].actual_arrival_time = "";

                                    updatedFlightDetails[
                                      index
                                    ].actual_flight_class = "";

                                    updatedFlightDetails[
                                      index
                                    ].same_as_original = false;
                                  }

                                  setActualFlightDetails(updatedFlightDetails);
                                }}
                              />
                              Same as Original Flight
                            </label>
                          )}
                        />
                      )}

                        <div className="grid-two">
                                          <div className="custom-input">
                      
                                              <label className="input-label">
                                              Search by
                                              {/* <span style={{ color: "#de8385" }}> *</span> */}
                                            </label>
                      
                                              <Radio.Group
                                                                            value={flight.search_by}
                                                onChange={(value) => {
                                                                              
                      
                                                   const updatedFlightDetails = [...actualFlightDetails];
                                                  updatedFlightDetails[index].search_by = value;
                                                  
                                                  setActualFlightDetails(updatedFlightDetails)
                                                                            }}
                                                                          >
                                                <div className="claim-form-radio-wrapper">
                                                  
                                                                              <Radio
                                                                                color="red"
                                                                                // checked
                                                                                variant="outline"
                                                                                value={"airline_name"}
                                                    label="Airline name"
                                                    size="xs"
                                                                  />
                                                                  
                                                                              <Radio
                                                                                color="red"
                                                                                variant="outline"
                                                                                value={"iata_code"}
                                                    label="Airline code"
                                                    size="xs"
                                                    
                                                                              />
                                                                            </div>
                                                                          </Radio.Group>
                                          </div>
                                          
                      
                                       
                      
                                         
                                        </div>
                      <div className="grid-two">
                        <div
                          className="custom-select"
                          style={{ width: "100%" }}
                        >

                           {/* <div className="airline-radio-wrapper">
                          
                                                  <Radio.Group
                                                                                value={flight.search_by}
                                                    onChange={(value) => {
                                                                                  
                          
                                                       const updatedFlightDetails = [...actualFlightDetails];
                                                      updatedFlightDetails[index].search_by = value;
                                                      
                                                      setActualFlightDetails(updatedFlightDetails)
                                                                                }}
                                                                              >
                                                                                <div className="claim-form-radio-wrapper">

                            <label className="search-by-label">Search by:</label>
                                
                                <Radio
                                                                                    color="red"
                                                                                    // checked
                                                                                    variant="outline"
                                                                                    value={"airline_name"}
                                                        label="Airline name"
                                                        size="xs"
                                                                      />
                                                                      
                                                                                  <Radio
                                                                                    color="red"
                                                                                    variant="outline"
                                                                                    value={"iata_code"}
                                                        label="Airline code"
                                                        size="xs"
                                                        
                                                                                  />
                                                                                </div>
                                                                              </Radio.Group>
                                                </div> */}
                          <span className="select-label">
                            Airline <span style={{ color: "#de8385" }}> *</span>
                          </span>
                          <div
                            className="select-box"
                            style={{
                              borderColor: "#E6F6FF",
                              backgroundColor: "#e8eef7",
                            }}
                          >
                            <Controller
                              name={`actual_flight_details[${index}].actual_airline`}
                              control={control}
                              rules={{
                                required:
                                  !actualFlightDetails[index]?.actual_airline,
                              }} // Mandatory for the first flight
                              render={({ field }) => (
                                <AsyncSelect
                                  {...field}
                                  styles={selectStyles}
                                  cacheOptions={false}
                                  defaultOptions={defaultAirlineOptions}
                                  loadOptions={(inputValue, callback) =>
        loadAirlineOptions(inputValue, flight.search_by || "airline_name", callback)
      }
                                  value={
                                    flight.actual_airline
                                      ? {
                                          label: flight.actual_airline,
                                          value: flight.actual_airline,
                                        }
                                      : null
                                  }
                                  placeholder="Select Airline"
                                  onChange={(selectedOption) => {
                                    setActualFlightDetails((prevState) => {
                                      const updatedFlightDetails = [
                                        ...prevState,
                                      ];
                                      updatedFlightDetails[
                                        index
                                      ].actual_hub_code =
                                        selectedOption?.hub_code || "";

                                      updatedFlightDetails[
                                        index
                                      ].actual_airline =
                                        selectedOption?.label || "";
                                      return updatedFlightDetails;
                                    });
                                    setTriggerIndex(index);
                                    setTriggerFrom("actual");
                                    field.onChange(selectedOption?.label || "");
                                    setFormValue(
                                      `actual_flight_details[${index}].actual_airline`,
                                      selectedOption?.label || ""
                                    );
                                  }}
                                />
                              )}
                            />
                          </div>

                          {errors.actual_flight_details?.[index]
                            ?.actual_airline && (
                            <p className="errormessage">
                              {
                                errors.actual_flight_details[index]
                                  .actual_airline.message
                              }
                            </p>
                          )}
                        </div>

                        <div className="custom-input" style={{ width: "100%" }}>
                          <label className="input-label">
                            Flight number
                            <span style={{ color: "#de8385" }}> *</span>
                          </label>
                          <Controller
                            name={`actual_flight_details[${index}].actual_flight_number`}
                            control={control}
                            rules={{
                              required: "Flight Number is Required",
                              validate: (value) => {
                                if (!/^[a-zA-Z0-9]+$/.test(value)) {
                                  return "Only letters and numbers are allowed";
                                }
                                if (value.length > 10) {
                                  // Change to 7 if needed
                                  return "Maximum 10 characters allowed";
                                }
                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                className="input-box"
                                placeholder="Enter flight number"
                                type="text"
                                value={flight.actual_flight_number}
                                maxLength={10}
                                onChange={(e) => {
                                  // Allow only alphanumeric, convert to uppercase
                                  const cleanedValue = e.target.value
                                    .replace(/[^a-zA-Z0-9]/g, "")
                                    .toUpperCase();

                                  // Prevent exceeding max length
                                  const truncatedValue = cleanedValue.slice(
                                    0,
                                    10
                                  ); // Change to 7 if needed

                                  const updatedFlightDetails = [
                                    ...actualFlightDetails,
                                  ];
                                  updatedFlightDetails[
                                    index
                                  ].actual_flight_number = truncatedValue;
                                  setActualFlightDetails(updatedFlightDetails);
                                  // setTriggerIndex(index);
                                  setTriggerFrom("actual");
                                  field.onChange(truncatedValue);
                                  setFormValue(
                                    `actual_flight_details[${index}].actual_flight_number`,
                                    truncatedValue
                                  );


                                            // debounce the "trigger" call so it fires only after typing stops
            if (typingTimeouts.current[index]) {
              clearTimeout(typingTimeouts.current[index]);
            }                       
                              typingTimeouts.current[index] = setTimeout(() => {

                                if (truncatedValue.length > 0) {

                                  setTriggerIndex(index);
                                  
                                } else {
                                  setTriggerIndex(null);
                                }

              // any other action that should run after typing stops
              delete typingTimeouts.current[index];
            }, DEBOUNCE_MS);

                                }}
                              />
                            )}
                          />
                          {errors.actual_flight_details?.[index]
                            ?.actual_flight_number && (
                            <p className="errormessage">
                              {
                                errors.actual_flight_details[index]
                                  .actual_flight_number.message
                              }
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="grid-two">
                        <div className="custom-date-time-container">
                          <label className="custom-date-time-label">
                            Departure date & time{" "}
                            <span style={{ color: "#de8385" }}>*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <div className="custom-date-time-box">
                              <Controller
                                name={`actual_flight_details[${index}].actual_date_of_travel`}
                                control={control}
                                defaultValue={flight.actual_date_of_travel}
                                rules={{
                                  required: "Travel Date is required",
                                  validate: validateDateFormat,
                                }}
                                render={({ field }) => (
                                  <CustomDOBPicker
                                    {...field}
                                    error={
                                      errors.actual_flight_details?.[index]
                                        ?.actual_date_of_travel?.message ||
                                      departureDateError
                                    }
                                    inputRequired={true}
                                    placeholder="Choose date"
                                    inputClassName="custom-date-input"
                                    onChange={(value) => {
                                      field.onChange(value);

                                      // Custom logic
                                      setDepartureDateError(null);
                                      const updatedFlightDetails = [
                                        ...actualFlightDetails,
                                      ];
                                      updatedFlightDetails[
                                        index
                                      ].actual_date_of_travel = value;
                                      setActualFlightDetails(
                                        updatedFlightDetails
                                      );
                                      setFormValue(
                                        `actual_flight_details[${index}].actual_date_of_travel`,
                                        value
                                      );
                                      setTriggerIndex(index);
                                      setTriggerFrom("actual");
                                      
                                    }}
                                  />
                                )}
                              />

                              <Controller
                                name={`actual_flight_details[${index}].actual_departure_time`}
                                control={control}
                                defaultValue={flight.actual_departure_time}
                                rules={{
                                  required: "Departure Time is required",
                                }}
                                render={({ field }) => (
                                  <>
                                 
                                  <input
                                    {...field}
                                    ref={timeRef}
                                    type={ flight.actual_departure_time !== "" ? "time": flight?.departureTimeInputType || "text"  }
                                    disabled ={flight?.manual !== true}
                                    onFocus={() => setTimeIndex("departureTimeInputType",index,"time")}
                                      onBlur={() => {
                                      
                                        if (flight.actual_departure_time === "") {
                                          setTimeIndex("departureTimeInputType",index,"text")
                                        } else {
                                          setTimeIndex("departureTimeInputType",index,"time")
                                        }
                                    }}
                                    placeholder="Time"
                                    className="custom-time-input"
                                    required
                                    // onKeyDown={handleTimeKeyDown}
                                    onChange={(e) => {
                                       const formatted = formatTimeInput(e.target.value);
    const corrected = autoCorrectTime(formatted);

    // Convert to AM/PM format
    // const corrected = moment(value, ["HH:mm", "hh:mm A"]).format("hh:mm A");

                                      
                                      console.log(corrected)
    // const corrected = autoCorrectTime(formatted);
                                      field.onChange(corrected);

                                      setDepartureDateError(null);
                                      const updatedFlightDetails = [
                                        ...actualFlightDetails,
                                      ];
                                      updatedFlightDetails[
                                        index
                                      ].actual_departure_time = corrected;
                                      setActualFlightDetails(
                                        updatedFlightDetails
                                      );

                                      setFormValue(
                                        `actual_flight_details[${index}].actual_departure_time`,
                                        corrected
                                      );
                                      setTriggerIndex(null);
                                    }}
                                  />

                                    {/* <span className="clock-icon">
                                      {
                                       flight?.departureTimeInputType !== "time" &&   <ClockIcon onClick={() => {
                                        
                                          if (flight?.manual === true) {
                                            
                                            setTimeIndex("departureTimeInputType",index,'time')
                                          }
                                        
                                      }} />
                                      }
                                    
                                    </span> */}
                                    
                                     </>
                                )}
                              />
                            </div>
                          </div>

                          {(errors.actual_flight_details?.[index]
                            ?.actual_date_of_travel ||
                            errors.actual_flight_details?.[index]
                              ?.actual_departure_time) && (
                            <p className="errormessage">
                              {errors.actual_flight_details?.[index]
                                ?.actual_date_of_travel?.message ||
                                errors.actual_flight_details?.[index]
                                  ?.actual_departure_time?.message ||
                                "Travel Date and Time is Required"}
                            </p>
                          )}
                        </div>

                        <div className="custom-input" style={{ width: "100%" }}>
                          <label className="input-label">
                            Airport of origin
                            <span style={{ color: "#de8385" }}> *</span>
                          </label>
                          <div
                            className="select-box"
                            style={{
                              borderColor: "#E6F6FF",
                              backgroundColor: "#e8eef7",
                            }}
                          >
                            {flightOptions[index] &&
                            flightOptions[index].length > 0 ? (
                              <div style={{ width: "100%" }}>
                                <Controller
                                  name={`actual_flight_details[${index}].actual_airport_of_origin`}
                                  control={control}
                                  rules={{
                                    required:
                                      !actualFlightDetails[index]
                                        ?.actual_airport_of_origin,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      styles={selectStyles}
                                      {...field}
                                      cacheOptions
                                      // defaultOptions={flightOptions[index].map(
                                      //   (option) => ({
                                      //     value: option.departure.airport,
                                      //     arrival: option.arrival.airport,
                                      //     departure: option.departure.airport,
                                      //     label: `${option.departure.airport} (${option.departure.iata}) - ${option.arrival.airport} (${option.arrival.iata})`,
                                      //   })
                                      // )}
                                      loadOptions={loadOptions}
                                      defaultOptions={defaultOptions}
                                     
                                    isDisabled ={flight?.manual !== true}

                                      value={
                                        flight.actual_airport_of_origin
                                          ? {
                                              label: flight.departure_iata_code
                                                ? flight.actual_airport_of_origin.includes(
                                                    "("
                                                  ) // Check if "(" exists
                                                  ? flight.actual_airport_of_origin // Keep original if it has parentheses
                                                  : `${flight.actual_airport_of_origin} (${flight.departure_iata_code})` // Else append IATA
                                                : flight.actual_airport_of_origin, // No IATA code? Show as-is
                                              value:
                                                flight.actual_airport_of_origin,
                                            }
                                          : null
                                      }
                                      placeholder="Select Origin Airport"
                                      onChange={(selectedOption) => {
                                        setTriggerIndex(null);
                                        const updatedFlightDetails = [
                                          ...actualFlightDetails,
                                        ];
                                        updatedFlightDetails[
                                          index
                                        ].actual_airport_of_origin =
                                          selectedOption?.label || "";
                                        setActualFlightDetails(
                                          updatedFlightDetails
                                        );
                                        field.onChange(
                                          selectedOption?.label || ""
                                        );
                                        setFormValue(
                                          `actual_flight_details[${index}].actual_airport_of_origin`,
                                          selectedOption?.label || ""
                                        );
                                      }}
                                    />
                                  )}
                                />
                               
                              </div>
                            ) : (
                              <div style={{ width: "100%" }}>
                                <Controller
                                  name={`actual_flight_details[${index}].actual_airport_of_origin`}
                                  control={control}
                                  rules={{
                                    required:
                                      !actualFlightDetails[index]
                                        ?.actual_airport_of_origin,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      {...field}
                                      styles={selectStyles}
                                      cacheOptions
                                      
                                      isDisabled ={flight?.manual !== true}
                                      loadOptions={loadOptions}
                                      defaultOptions={defaultOptions}
                                      value={
                                        flight.actual_airport_of_origin
                                          ? {
                                              label:
                                                flight.actual_airport_of_origin,
                                              value:
                                                flight.actual_airport_of_origin,
                                            }
                                          : null
                                      }
                                      placeholder="Select Origin Airport"
                                      onChange={(selectedOption) => {
                                        setTriggerIndex(null);
                                        const updatedFlightDetails = [
                                          ...actualFlightDetails,
                                        ];
                                        updatedFlightDetails[
                                          index
                                        ].actual_airport_of_origin =
                                          selectedOption?.label || "";
                                        setActualFlightDetails(
                                          updatedFlightDetails
                                        );
                                        field.onChange(
                                          selectedOption?.label || ""
                                        );
                                        setFormValue(
                                          `actual_flight_details[${index}].actual_airport_of_origin`,
                                          selectedOption?.label || ""
                                        );
                                      }}
                                    />
                                  )}
                                />

                              
                              </div>
                            )}
                          </div>

                           {errors.actual_flight_details?.[index]
                                  ?.actual_airport_of_origin && (
                                  <p className="errormessage">
                                    {
                                      errors.actual_flight_details[index]
                                        .actual_airport_of_origin.message
                                    }
                                  </p>
                                )}
                        </div>
                      </div>
                      <div className="grid-two">
                        <div className="custom-date-time-container">
                          <label className="custom-date-time-label">
                            Arrival date & time{" "}
                            <span style={{ color: "#de8385" }}>*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <div className="custom-date-time-box">
                              <Controller
                                name={`actual_flight_details[${index}].actual_arrival_date`}
                                control={control}
                                defaultValue={flight.actual_arrival_date}
                                rules={{
                                  required: "Arrival Date is required",
                                  validate: validateDateFormat,
                                }}
                                render={({ field }) => (
                                  <CustomDOBPicker
                                    {...field}
                                    error={
                                      errors.actual_flight_details?.[index]
                                        ?.actual_arrival_date?.message ||
                                      dateError
                                    }
                                    disabled ={flight?.manual !== true}
                                    inputRequired={true}
                                    placeholder="Choose date"
                                    inputClassName="custom-date-input"
                                    onChange={(value) => {
                                      field.onChange(value);
                                      setDateError(null);
                                      const updatedFlightDetails = [
                                        ...actualFlightDetails,
                                      ];
                                      updatedFlightDetails[
                                        index
                                      ].actual_arrival_date = value;
                                      setActualFlightDetails(
                                        updatedFlightDetails
                                      );
                                      setFormValue(
                                        `actual_flight_details[${index}].actual_arrival_date`,
                                        value
                                      );
                                      setTriggerIndex(null);
                                    }}
                                  />
                                )}
                              />

                              <Controller
                                name={`actual_flight_details[${index}].actual_arrival_time`}
                                control={control}
                                defaultValue={flight.actual_arrival_time}
                                rules={{
                                  required: "Arrival Time is required",
                                }}
                                render={({ field }) => (
                                   <>
                                  <input
                                    {...field}
                                    ref={timeRef}
                                    disabled ={flight?.manual !== true}
                                   type={ flight.actual_arrival_time !== "" ? "time": flight?.arrivalTimeInputType || "text"  }
                                        onFocus={() => setTimeIndex("arrivalTimeInputType",index,"time")}
                                      onBlur={() => {
                                      
                                        if (flight.actual_departure_time === "") {
                                          setTimeIndex("arrivalTimeInputType",index,"text")
                                        } else {
                                          setTimeIndex("arrivalTimeInputType",index,"time")
                                        }
                                    }}
                                  //   // onFocus={() => setTimeInputType2("time")}
                                  //  onBlur={() => setTimeIndex("arrivalTimeInputType",index,"text")}
                                    placeholder="Time"
                                    className="custom-time-input"
                                    required
                                    onChange={(e) => {
                                       const formatted = formatTimeInput(e.target.value);
    const corrected = autoCorrectTime(formatted);
                                      field.onChange(corrected);
                                      setDateError(null);
                                      const updatedFlightDetails = [
                                        ...actualFlightDetails,
                                      ];
                                      updatedFlightDetails[
                                        index
                                      ].actual_arrival_time = corrected;
                                      setActualFlightDetails(
                                        updatedFlightDetails
                                      );
                                      setFormValue(
                                        `actual_flight_details[${index}].actual_arrival_time`,
                                        corrected
                                      );
                                      setTriggerIndex(null);
                                    }}
                                  />

                                    {/* <span className="clock-icon">
                                      {
                                        flight?.arrivalTimeInputType !== "time" &&   <ClockIcon onClick={() => {
                                        
                                          if (flight?.manual === true) {
                                            
                                            setTimeIndex("arrivalTimeInputType",index,'time')
                                          }
                                        
                                      }} />
                                      }
                                    
                                    </span> */}
                                  
                                   </>
                                )}
                              />
                            </div>
                          </div>

                          {/* {dateError && (
                            <div style={{ color: "red", marginTop: "5px" }}>
                              {dateError}
                            </div>
                          )} */}

                          {(errors.actual_flight_details?.[index]
                            ?.actual_arrival_date ||
                            errors.actual_flight_details?.[index]
                              ?.actual_arrival_time) && (
                            <p className="errormessage">
                              {errors.actual_flight_details?.[index]
                                ?.actual_arrival_date?.message ||
                                errors.actual_flight_details?.[index]
                                  ?.actual_arrival_time?.message ||
                                "Arrival Date and Time is Required"}
                            </p>
                          )}
                        </div>

                        <div
                          className="custom-select"
                          style={{ width: "100%" }}
                        >
                          <span className="select-label">
                            Airport of destination{" "}
                            <span style={{ color: "#de8385" }}> *</span>
                          </span>
                          <div
                            className="select-box"
                            style={{
                              borderColor: "#E6F6FF",
                              backgroundColor: "#e8eef7",
                            }}
                          >
                            {flightOptions[index] &&
                            flightOptions[index].length > 0 ? (
                              <div style={{ width: "100%" }}>
                                <Controller
                                  name={`actual_flight_details[${index}].actual_airport_of_destination`}
                                  control={control}
                                  rules={{
                                    required:
                                      !actualFlightDetails[index]
                                        ?.actual_airport_of_destination,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      {...field}
                                      cacheOptions
                                      // defaultOptions={flightOptions[index].map(
                                      //   (option) => ({
                                      //     value: option.arrival.airport,
                                      //     arrival: option.arrival.airport,
                                      //     departure: option.departure.airport,
                                      //     label: `${option.departure.airport} (${option.departure.iata}) - ${option.arrival.airport} (${option.arrival.iata})`,
                                      //   })
                                      // )}
                                      loadOptions={loadOptions}
                                      defaultOptions={defaultOptions}
                                      isDisabled ={flight?.manual !== true}
                                      value={
                                        flight.actual_airport_of_destination
                                          ? {
                                              label: flight.arrival_iata_code
                                                ? flight.actual_airport_of_destination.includes(
                                                    "("
                                                  ) // Check for existing parentheses
                                                  ? flight.actual_airport_of_destination // Keep original if parentheses exist
                                                  : `${flight.actual_airport_of_destination} (${flight.arrival_iata_code})` // Append IATA if no parentheses
                                                : flight.actual_airport_of_destination, // Show as-is if no IATA code
                                              value:
                                                flight.actual_airport_of_destination,
                                            }
                                          : null
                                      }
                                      placeholder="Select Origin Airport"
                                      onChange={(selectedOption) => {
                                        setTriggerIndex(null);
                                        const updatedFlightDetails = [
                                          ...actualFlightDetails,
                                        ];
                                        updatedFlightDetails[
                                          index
                                        ].actual_airport_of_destination =
                                          selectedOption?.label || "";
                                        setActualFlightDetails(
                                          updatedFlightDetails
                                        );
                                        field.onChange(
                                          selectedOption?.label || ""
                                        );
                                        setFormValue(
                                          `actual_flight_details[${index}].actual_airport_of_destination`,
                                          selectedOption?.label || ""
                                        );
                                      }}
                                      styles={selectStyles}
                                    />
                                  )}
                                />
                               
                              </div>
                            ) : (
                              <div style={{ width: "100%" }}>
                                <Controller
                                  name={`actual_flight_details[${index}].actual_airport_of_destination`}
                                  control={control}
                                  defaultValue={
                                    flight.actual_airport_of_destination
                                  }
                                  rules={{
                                    required:
                                      !actualFlightDetails[index]
                                        ?.actual_airport_of_destination,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      {...field}
                                      cacheOptions
                                      loadOptions={loadOptions}
                                      defaultOptions={defaultOptions}
                                      isDisabled ={flight?.manual !== true}
                                      value={
                                        flight.actual_airport_of_destination
                                          ? {
                                              label:
                                                flight.actual_airport_of_destination,
                                              value:
                                                flight.actual_airport_of_destination,
                                            }
                                          : null
                                      }
                                      placeholder="Select Destination Airport"
                                      onChange={(selectedOption) => {
                                        setTriggerIndex(null);
                                        const updatedFlightDetails = [
                                          ...actualFlightDetails,
                                        ];
                                        updatedFlightDetails[
                                          index
                                        ].actual_airport_of_destination =
                                          selectedOption?.label || "";
                                        setActualFlightDetails(
                                          updatedFlightDetails
                                        );
                                        field.onChange(
                                          selectedOption?.label || ""
                                        );
                                        setFormValue(
                                          `actual_flight_details[${index}].actual_airport_of_destination`,
                                          selectedOption?.label || ""
                                        );
                                      }}
                                      styles={selectStyles}
                                    />
                                  )}
                                />

                              
                              </div>
                            )}
                          </div>
                           {errors.actual_flight_details?.[index]
                                  ?.actual_airport_of_destination && (
                                  <p className="errormessage">
                                    {
                                      errors.actual_flight_details[index]
                                        .actual_airport_of_destination.message
                                    }
                                  </p>
                                )}
                        </div>
                      </div>
                      <div className="grid-two">
                        {/* <div className="custom-input" style={{ width: "100%" }}>
                          <label className="input-label">
                            Ticket reference (PNR code)
                            <span style={{ color: "#de8385" }}> *</span>
                          </label>
                          <Controller
                            name={`actual_flight_details[${index}].ticket_ref_no`}
                            control={control}
                            rules={{
                              required: "PNR code is required",
                              validate: (value) => {
                                if (!/^[a-zA-Z0-9]+$/.test(value)) {
                                  return "Only letters and numbers are allowed";
                                }
                                if (value.length < 6) {
                                  return "Minimum 6 characters required";
                                }
                                if (value.length > 10) {
                                  return "Maximum 10 characters allowed";
                                }
                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                className="input-box"
                                placeholder="ABC123"
                                type="text"
                                value={flight.ticket_ref_no}
                                maxLength={10}
                                onChange={(e) => {
                                  // Allow only alphanumeric, convert to uppercase
                                  const cleanedValue = e.target.value
                                    .replace(/[^a-zA-Z0-9]/g, "")
                                    .toUpperCase();

                                  // Prevent exceeding max length
                                  const truncatedValue = cleanedValue.slice(
                                    0,
                                    10
                                  );

                                  const updatedFlightDetails = [
                                    ...actualFlightDetails,
                                  ];
                                  updatedFlightDetails[index].ticket_ref_no =
                                    truncatedValue;
                                  setActualFlightDetails(updatedFlightDetails);
                                  // setTriggerIndex(index);
                                  // setTriggerFrom("actual");
                                  field.onChange(truncatedValue);
                                  setFormValue(
                                    `actual_flight_details[${index}].ticket_ref_no`,
                                    truncatedValue
                                  );
                                }}
                              />
                            )}
                          />
                          {errors.actual_flight_details?.[index]
                            ?.ticket_ref_no && (
                            <p className="errormessage">
                              {
                                errors.actual_flight_details[index]
                                  .ticket_ref_no.message
                              }
                            </p>
                          )}
                        </div> */}
                        <div
                          className="custom-select"
                          style={{ width: "100%" }}
                        >
                          <span className="select-label">
                            Flight class{" "}
                            <span style={{ color: "#de8385" }}> *</span>
                          </span>
                          <div
                            className="select-box"
                            style={{
                              borderColor: "#E6F6FF",
                              backgroundColor: "#e8eef7",
                            }}
                          >
                            <Controller
                              name={`actual_flight_details[${index}].actual_flight_class`}
                              control={control}
                              // rules={{ required: "Flight class is required" }}
                              render={({ field }) => (
                                <AsyncSelect
                                  {...field}
                                  cacheOptions
                                  loadOptions={(val, callback) => {
                                    callback(
                                      flightClassOptions.filter((option) =>
                                        option.label
                                          .toLowerCase()
                                          .includes(val.toLowerCase())
                                      )
                                    );
                                  }}
                                  defaultOptions={flightClassOptions}
                                  value={
                                    flight.actual_flight_class
                                      ? flightClassOptions.find(
                                          (opt) =>
                                            opt.value ===
                                            flight.actual_flight_class
                                        )
                                      : null
                                  }
                                  placeholder="Select class"
                                  onChange={(selectedOption) => {
                                    const value = selectedOption?.value || "";
                                    const updatedFlightDetails = [
                                      ...actualFlightDetails,
                                    ];
                                    updatedFlightDetails[
                                      index
                                    ].actual_flight_class = value;
                                    setActualFlightDetails(
                                      updatedFlightDetails
                                    );
                                    field.onChange(value);
                                    setFormValue(
                                      `actual_flight_details[${index}].actual_flight_class`,
                                      value
                                    );
                                  }}
                                  styles={selectStyles}
                                />
                              )}
                            />
                          </div>
                          {errors.actual_flight_details?.[index]
                            ?.actual_flight_class && (
                            <p className="errormessage">
                              {
                                errors.actual_flight_details[index]
                                  .actual_flight_class.message
                              }
                            </p>
                          )}
                        </div>


                        
                        {

                          // (flight.actual_departure_time === "" || flight.actual_airport_of_origin === "" || flight.actual_arrival_time === "" || flight.actual_arrival_date === "" || flight.actual_airport_of_destination === "") &&
                          
                          <div className="custom-input">

                            <label className="input-label">Flight info didn't appear ?</label>
                            <button   className="btn btn-manual" type="button" onClick={() => {
                              setManualEntryIndex(index);
                            }} >

enter manually

                            </button>
                              
                          </div>

                        }


                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </>
        )}
      </form>
    </div>
  );
};

export default ActualFlightTaken;
